import { jsx } from "react/jsx-runtime";
const CloseCircleIcon = (props) => /* @__PURE__ */ jsx("svg", { ...props, viewBox: "0 0 1024 1024", children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 512C64 264.6 264.6 64 512 64C759.4 64 960 264.6 960 512C960 759.4 759.4 960 512 960C264.6 960 64 759.4 64 512ZM326.128 379.869C323.785 377.525 323.785 373.726 326.128 371.383L371.383 326.128C373.726 323.785 377.525 323.785 379.868 326.128L512 458.26L644.132 326.128C646.475 323.785 650.274 323.785 652.617 326.128L697.872 371.383C700.215 373.726 700.215 377.525 697.872 379.869L565.74 512.001L697.872 644.133C700.215 646.476 700.215 650.275 697.872 652.618L652.617 697.873C650.274 700.216 646.475 700.216 644.132 697.873L512 565.741L379.868 697.873C377.525 700.216 373.726 700.216 371.383 697.873L326.128 652.618C323.785 650.275 323.785 646.476 326.128 644.133L458.26 512.001L326.128 379.869Z"
  }
) });
export {
  CloseCircleIcon
};
